export default function DetailModal({ open, onClose, title, description, date }) {
  if (!open) return null;

  const formattedDate = date
    ? new Date(date).toLocaleDateString("en-US", {
      weekday: "short",
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    })
    : null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-xs transition-opacity"
        onClick={onClose}
      ></div>

      <div className="relative bg-white rounded-2xl p-6 w-full max-w-md mx-4 shadow-xl transform transition-all scale-95 animate-fadeIn">

        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>

        {formattedDate && (
          <p className="text-sm text-gray-500 mt-1 mb-4">{formattedDate}</p>
        )}

        <p className="text-gray-700 text-base leading-relaxed mb-6">
          {description || "No details available."}
        </p>

        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-gray-900 text-white hover:bg-gray-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
